import { css } from "@emotion/core"
import { theme } from "../constants"

export const searchBarContainerStyles = css`
  width: 300px;

  .ant-select-focused
    .ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: none !important;
    &:hover {
      background-color: none !important;
    }
  }

  input {
    position: relative;
    width: 300px;
    height: 25px;
    background-color: #17183d;
    border: none;
    color: white;
    border-radius: 45px;
    mix-blend-mode: normal;

    &:focus {
      border: none;
    }
  }

  .ant-select-selection-placeholder {
    position: absolute;
    left: 15px;
    padding: 4px;
  }
  .ant-select-selection-placeholder {
    font-size: ${theme.fontSizes[2]};
    color: white;
    font-family: ${theme.fonts.primary};
  }
`
